module.exports = __webpack_public_path__ + "static/img/57-2.62e4665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/57-2.jpg
// module id = v653
// module chunks = 0